import React from 'react';
import MonthlyOrderVolume from '../components/dashboard/MonthlyOrderVolume';
import TopSalespersonsByQuotes from '../components/dashboard/topSalesPerson';
import RevenueRanking from '../components/dashboard/revenueRanking';
import NetRevenue from '../components/dashboard/NetRevenue';
import ArticleSalesBarChart from '../components/dashboard/ArticleSalesChart';
import ProfitabilityAnalysis from '../components/dashboard/ProfitabilityAnalysis';
import LowStock from '../components/dashboard/LowStock';
import { Row, Col, Card } from 'antd';
import { useFetchAllArticles } from '../hooks/articleHooks';
import { useArticleSalesData } from '../hooks/useDashboardRevenue';

const DashboardRevenuePage = () => {
    const { articles, loading, error } = useFetchAllArticles();

    return (
        <div style={{ margin: '24px' }}>
          <Card title="Revenue & Profitability Dashboard" bordered={false} headStyle={{ fontSize: '24px', fontWeight: 'bold' }}>
            <NetRevenue />
    
            <Row gutter={16} style={{ marginTop: '24px' }}>
              <Col span={12}>
                <MonthlyOrderVolume />
              </Col>
              <Col span={12}>
                <TopSalespersonsByQuotes />
              </Col>
            </Row>
    
            <Row gutter={16} style={{ marginTop: '24px' }}>
              <Col span={12}>
                <RevenueRanking />
              </Col>
              <Col span={12}>
                <ArticleSalesBarChart articles={articles} />
              </Col>
            </Row>

            <Row gutter={16} style={{ marginTop: '24px' }}>
              <Col span={12}>
                <ProfitabilityAnalysis />
              </Col>
              <Col span={12}>
                <LowStock />
              </Col>
            </Row>
          </Card>
        </div>
      );
    };
export default DashboardRevenuePage;
